const getMessageTrackingId = (internetMessageHeaders: MicrosoftInternetHeaders[] | undefined) => {
  if (!internetMessageHeaders) return undefined
  return internetMessageHeaders.find((header) => header.name === 'x-tracking-id')?.value
}

export { getMessageTrackingId }
